// Stroke-based Google "G" icon to match Lucide style
export default function GoogleIcon({ size = 16, strokeWidth = 1.5, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21.5 12.2c0-.7-.06-1.36-.18-2H12v3.78h5.34c-.23 1.24-.93 2.29-1.99 2.99v2.48h3.21c1.88-1.73 2.94-4.28 2.94-7.25z" />
      <path d="M12 22c2.7 0 4.96-.9 6.6-2.42l-3.21-2.48c-.9.6-2.04.96-3.39.96-2.6 0-4.81-1.76-5.6-4.13H3.06v2.6C4.7 19.81 8.07 22 12 22z" />
      <path d="M6.4 13.93a6.04 6.04 0 010-3.85V7.48H3.06a10 10 0 000 9.04l3.34-2.59z" />
      <path d="M12 5.83c1.47 0 2.79.5 3.83 1.5l2.85-2.85C16.95 2.88 14.7 2 12 2 8.07 2 4.7 4.19 3.06 7.48L6.4 10.07C7.19 7.7 9.4 5.83 12 5.83z" />
    </svg>
  );
}
